import LoginHero from '@/components/authentication/login-hero';
import { useAuth } from '@/hooks/use-auth';
import { useResponsive } from '@/hooks/use-responsive';
import NotFound from '@/pages/NotFound';
import { themeVar } from '@/styles/theme';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';

export const AuthLayout = () => {
  const { isMobile, isTablet, isPortrait } = useResponsive();
  const { user } = useAuth();
  const location = useLocation();

  if ((location.pathname === '/change-password' || location.pathname === '/two-factor-authentication') && user && user?.impersonated) {
    return <NotFound />;
  }
  return (
    <Container isMobile={isMobile} isTablet={isTablet} isPortrait={isPortrait}>
      {isMobile || (isPortrait && isTablet) ? (
        <HeroBlockMobile>
          <LoginHero />
        </HeroBlockMobile>
      ) : (
        <HeroBlock>
          <LoginHero />
        </HeroBlock>
      )}
      <MainContentWrapper width={isMobile || (isPortrait && isTablet) ? '100%' : '50%'}>
        <Outlet />
      </MainContentWrapper>
    </Container>
  );
};

const Container = styled.div<{ isMobile: boolean; isTablet: boolean; isPortrait: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${({ isMobile, isTablet, isPortrait }) => (isMobile || (isPortrait && isTablet) ? 'column' : 'row')};
  justify-content: center;
`;

const HeroBlock = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: ${themeVar('loginBg')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  overflow: hidden;
`;

const HeroBlockMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36%;
  margin-bottom: 50px;
  background-color: ${themeVar('loginBg')};
`;

const MainContentWrapper = styled.div<{ width: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-self: center;
  gap: 30px;
  height: auto;
  margin-top: 30px;
  width: ${({ width }) => width};
  background-color: ${themeVar('layer.base')};
`;
